import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserHeader from "../user/UserHeader";
import UserMenu from "../user/UserMenu";
import "../../assets/css/style1.css";


const Layout = ({ children ,isLoggedIn,isDefaultUrl }) => {
   
    // const navigate = useNavigate();
    // function navigateURL(component) {
    //     window.location.href = globalThis.config.Settings.ApiConfiguration.Appurl;
    // }

    // window.addEventListener('popstate', () => {

    //     navigate(location.pathname.includes('/as')) ? navigateURL("/as") : navigateURL("/");
       
        
    //     });
    return (
        <>
            <UserHeader />
            {isLoggedIn && !isDefaultUrl ? (
                <>
                    <div className='top-position-menu'>
                        <UserMenu />
                    </div>
                    <main id="main" className={"menu-left-0"}>
                        <div>
                            <div>{children}</div>
                        </div>
                    </main>
                </>
            ) : (
                <div >{children}</div>
            )}
        </>
    );
}

export default Layout;
